<template>
  <div>
    <h1 class="page-header">Customer Profiles</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button outline color="info" @click="$router.push({ name: 'customer-profile-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" class="kh-font" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td class="kh-font">{{ record.customer_name }}</td>
          <td>{{ record.gender }}</td>
          <td>{{ record.contact_no }}</td>
          <td>{{ record.email }}</td>
          <td>{{ $store.getters.limitStringShow(record.description) }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'customer-profile-edit',
                params: { id: record.customer_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>
            <a href="#" title="delete" class="text-danger" @click="destroy(record.customer_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'customer-profile',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'name', style: 'width: 20%' },
        { name: 'gender', style: 'width: 5%' },
        { name: 'contact no', style: 'width: 15%' },
        { name: 'email', style: 'width: 10%' },
        { name: 'description' },
        { name: 'Action', style: 'width: 1px' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/customerProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.customerProfile.search
      },
      set(newValue) {
        this.$store.commit('administration/customerProfile/SET_SEARCH', newValue)
        this.$store.commit('administration/customerProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administration/customerProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('administration/customerProfile/deleteadministration/CustomerProfile', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'customer-profile-create') {
      this.$store.commit('administration/customerProfile/RESET_STATE')
    }
    next()
  }
}
</script>
